import type { IUserData } from 'v2/interfaces/user';

const LEGAL_PERSON_ACCOUNT_TYPE: IUserData['type'] = 'J';

export function isLegalPersonAccount(accountType?: IUserData['type']): boolean {
  return accountType === LEGAL_PERSON_ACCOUNT_TYPE;
}
